/**
 * Talking to an NPC (ADR-136 decision 5): why a `talk` was refused, by the code its `interaction` carries, and the
 * dialogue window's own words. The NPC's lines are not here: they live in the dialogue files as line records
 * (ADR-119 decision 5). `refused.combat` is the author's ruling 5 of 2026-10-27; `refused.busy` and the window's words
 * are the author's choice of 2026-10-28, as are the marks' tooltips (what a mark is, the attribute a check reads, its
 * chance). `naming` is the companion's naming at the offer (ADR-142 decision 5.4, P2.26-T7): the field's label, its
 * hint, the button that sends the name, and why a name was refused, by the state `companionNaming` carries; drafts for
 * the author. `tier` is the mood tier's tooltip (ADR-146 decision 8.2): the pips' accessible name, the next tier, the beast master's section and whether a feed is
 * still wanted today, drafts for the author. `backgrounds` names the backgrounds of Bible 4.2 by their ids in the rules table `backgrounds`, written in camel case; `unknown` stands for an id the page does not name.
 */
export const TALK = {
  refused: {
    combat: "They eye your blade and wait.",
    busy: "They have no time for talk just now.",
  },
  label: "Conversation with {name}",
  leave: "Leave",
  tier: {
    label: "{tier}, {at} of {of}",
    next: "Next: {tier}",
    lore: {
      title: "What a beast master knows",
      rapport: "Rapport {have} of {need} to {tier}",
      wants: "He would take a worm today.",
    },
    hungry: "He has not eaten today.",
    fed: "He has eaten.",
  },
  naming: {
    label: "His name",
    hint: "3 to 12 letters, digits, _ or -",
    submit: "Name him",
    refused: {
      shape: "That name is not acceptable.",
      reserved: "That name holds a word kept for the staff.",
      taken: "Another of your companions has that name.",
    },
  },
  marks: {
    check: "{attribute} check",
    stat: "Affected by {attribute}",
    chance: "{percent}% chance",
    background: "Background choice",
    backgroundNeeds: "Open to a {background}",
    locked: "Locked",
    lockedNeeds: "Needs {need}",
    significant: "Significant choice",
    defining: "Defining choice",
  },
  attributes: {
    might: "Might",
    agility: "Agility",
    vitality: "Vitality",
    intellect: "Intellect",
    willpower: "Willpower",
    perception: "Perception",
    presence: "Presence",
  },
  backgrounds: {
    lyceumApplicant: "Lyceum Applicant",
    streetSurvivor: "Street Survivor",
    guildApprentice: "Guild Apprentice",
    hedgePractitioner: "Hedge Practitioner",
    fallenNoble: "Fallen Noble",
    wanderer: "Wanderer",
    unknown: "certain background",
  },
} as const;
